import React, { useState } from "react";
import APIService from "../../../modules/apiService";
import { useBillingContext } from "..";

const api = new APIService();

export default function DeleteBillingSettings() {
  const { showErrorModal, setBillingSettings } = useBillingContext();
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDeleteCert = async () => {
    setIsDeleting(true);

    try {
      const response = await api.deleteBillingSettings();
      const json = await response.json();

      if (response.ok) {
        setBillingSettings(null);
      } else {
        throw new Error(json?.message);
      }
    } catch (err) {
      showErrorModal(err.message);
    }

    setIsDeleting(false);
  };

  return (
    <div>
      <div className="alert alert-warning">
        <i className="fa fa-exclamation-triangle mr-2"></i>
        <strong className="mr-1">¡Atención!</strong> Si eliminas tu certificado, ya no podrás emitir facturas hasta que generes uno nuevo.
      </div>

      {!showDeleteConfirm ? (
        <button className="btn btn-danger" onClick={() => setShowDeleteConfirm(true)}>
          Eliminar certificado
        </button>
      ) : (
        <div className="card border-danger mt-3">
          <div className="card-body">
            <h5 className="card-title">¿Estás seguro?</h5>
            <p className="card-text">Esta acción no se puede deshacer. Perderás toda la conexión con ARCA (AFIP) y deberás generar un nuevo certificado para volver a facturar.</p>
            <div className="d-flex mt-3">
              <button className="btn btn-danger mr-2" onClick={handleDeleteCert} disabled={isDeleting}>
                {isDeleting ? (
                  <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                    <div className="spinner-border spinner-border-sm" role="status" />
                    Eliminando...
                  </div>
                ) : (
                  "Sí, eliminar certificado"
                )}
              </button>
              <button className="btn btn-secondary" onClick={() => setShowDeleteConfirm(false)} disabled={isDeleting}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
